import React from "react";
import {Loader} from "rsuite";

const Loading = () => {
  return <Loader center backdrop size="md"/>
}

export default Loading
